import api from '../config/api';

/**
 * Miscellaneous Service - Handles static/public data like countries
 */
class MiscService {
  /**
   * Get list of supported countries
   */
  async getCountries() {
    try {
      const response = await api.get('/misc/countries');
      return response.data.data || [];
    } catch (error) {
      console.error('Error fetching countries:', error);
      return [];
    }
  }

  /**
   * Get list of supported currencies
   */
  async getCurrencies() {
    try {
      const response = await api.get('/misc/currencies');
      return response.data.data || [];
    } catch (error) {
      console.error('Error fetching currencies:', error);
      return [];
    }
  }

  /**
   * Get Delhivery International charge config (GST %, FSR %, PSC ₹)
   */
  async getDelhiveryIntlCharges() {
    try {
      const response = await api.get('/misc/delhivery-international-charges');
      return response.data.data || null;
    } catch (error) {
      console.error('Error fetching Delhivery International charges:', error);
      return null;
    }
  }

  /**
   * Get company invoice settings (null when not configured or backend down)
   */
  async getInvoiceSettings() {
    try {
      const response = await api.get('/misc/invoice-settings');
      return response.data.data || null;
    } catch (error) {
      console.error('Error fetching invoice settings:', error);
      return null;
    }
  }
}

const miscService = new MiscService();
export default miscService;
